import { EXCHANGE_DECIMALS } from 'config/constants';

// https://stargateprotocol.gitbook.io/stargate/developers/contract-addresses/mainnet
// https://github.com/idexio/idex-sdk-js-ikon/blob/beta/src/bridge/constants.ts (single point of truth)

/**
 * Allowed Slippage
 * 0.999 => 0.1%
 * 0.98  =>   2% Updated for V2
 */
export const MIN_DEPOSIT_QUANTITY_MULTIPLIER = 0.98; // 0.999;

/** Slippage */
export const MIN_DEPOSIT_QUANTITY_MULTIPLIER_PIPS = BigInt(
  MIN_DEPOSIT_QUANTITY_MULTIPLIER * 10 ** EXCHANGE_DECIMALS
);
